import cx from 'clsx'
import React, { CSSProperties } from 'react'

import cn from '../styles.module.scss'

import { IBlockProps } from '../Block/Block'

export interface ISectionProps extends IBlockProps {
  factor?: number
}

export interface CustomSectionCSS extends CSSProperties {
  '--pad-section': string
}

const Section = ({
  children,
  bgColor,
  align,
  direction,
  className,
  factor = 1,
  style,
  ...rest
}: ISectionProps) => {
  const classes = cx(
    cn.padSection,
    bgColor && cn[bgColor],
    bgColor && cn[bgColor],
    align && cn[align],
    direction && cn[direction],
    className,
  )

  return (
    <section
      {...rest}
      className={classes}
      style={
        { '--pad-section': `${8 * factor}px`, ...style } as CustomSectionCSS
      }
    >
      {children}
    </section>
  )
}

export default Section
